import { Configuration, ConfigurationResponse } from '~/core/configuration/configuration.type';

/**
 * Fetches and parses the client configuration from the given URL
 *
 * @param clientConfigURL - URL to fetch the client configuration from
 *
 * @returns parsed client configuration
 */
const getClientConfig = async (clientConfigURL: string): Promise<Configuration> => {
    return new Promise((resolve, reject) => {
        fetch(clientConfigURL)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            // TODO: consder runtime type checking
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            .then((json: ConfigurationResponse) => {
                if (json.error) {
                    reject(json.error);
                }
                resolve(json.data);
            })
            .catch((e) => {
                console.error('SEARCH READY ERROR: config loading failed');
                reject(e);
            });
    });
};

export default getClientConfig;
